import React from 'react';
import './MobileDropdown.scss';

/*
    Usage:
        1. Override @media query for scss class '__component_mobile-dropdown'
            -  @media only screen and (max-width: 768px)
*/

type MobileDropdownProps = {
    open: boolean,
    options: { id: string, name: string, href: string }[],
    activePage: string,
};

export const MobileDropdown = ({ open, options, activePage }: MobileDropdownProps) => {
    return (
        <div className={`__component_mobile-dropdown ${open ? 'active' : ''}`}>
            <div>
                {
                    options && options.map(x => (
                        <a href={x.href}>
                            <div className={`__component_mobile-dropdown_nav-item ${activePage === x.id ? 'active' : ''}`}>
                                {x.name}
                            </div>
                        </a>
                    ))
                }
            </div>
        </div>
    );
};
